<template>
	<div class="page" style="background-image: url(./images/ivst_bg.png); background-size: cover; overflow: auto;">
		<div style="padding: 15px;" v-show="showSearch">
			<div style=" width: 40%; margin: 0 auto; padding-top: 30vw;">
				<img :src="'./images/njcj_ivstlogo.png'" style="width: 100%;" />
			</div>
			<div style="height: 15vw;"></div>
			<!-- 	<van-field v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" /> -->
			<div style="width: 70%; margin: 0 auto; border: 1px solid #ffffff; border-left: 0; border-right: 0;">
				<van-field style="background-color: rgba(0,0,0,0);" v-model="stuForm.username" placeholder="请输入您的账号" />
			</div>
			<div style="width: 70%; margin: 0 auto; border-bottom: 1px solid #ffffff;">
				<van-field style="background-color: rgba(0,0,0,0);" type="password" v-model="stuForm.password" placeholder="请输入您的密码" />
			</div>
			<div style="height: 50px;"></div>
			<div class="btntj" v-if="!joined" @click="onSearch"
				style="width: 40%; margin: 0 auto; border-radius: 20px;">登 录</div>
			<div style="height: 50px;"></div>
		</div>


		<div v-show="!showSearch"
			style="height: 100%;background-image: url(./images/form_bg.png); background-color: #fff; background-size: cover; overflow: auto;">
			<div style="text-align: center; line-height: 60px;">
				{{class_name}}
			</div>


			<div style="width: 90%; margin: 0 auto;">
				<table class="gridtable">
					<tr>
						<th>序号</th>
						<th>姓名</th>
						<th>学号</th>
						<th>是否参与</th>
					</tr>
					<tr v-for="(item,idx) in DataList" :key="idx">
						<td>{{idx+1}}</td>
						<td>{{item.stu_name}}</td>
						<td>{{item.xuejihao}}</td>
						<td>
							<span v-if="item.wenjuan">
								已参与
							</span>
							<span v-else style="color: orangered;">未参与</span>
						</td>
					</tr>
				</table>
			</div>
			
			<div style="height: 50px;">
				
			</div>


		</div>


	</div>
</template>

<script>
	import {
		Dialog,
		Toast
	} from 'vant';
	export default {
		props: ['ivstid', "userid"],
		data() {
			return {
				showSearch: true,
				pmid: 4,
				openid: "",
				ivst_id: 0,
				teacher_id:0,
				DataList: [],
				joined: false,
				viewResult: false,
				expired: false, //是否过期
				class_id: 0,
				class_name: "",
				stuForm: {
					username: "",
					password: ""
				},
				stuInfo: {

				}
			}
		},
		mounted() {
			document.title = "问卷调查填写情况"
			//this.getList();

			this.openid = this.$route.query.openid
			this.ivst_id = this.$route.query.id
			this.pmid = this.$route.query.pmid
			if (!this.openid) {
				Dialog.alert({
					title: '提示',
					message: '获取微信授权信息错误，请重新扫码进入！',
					theme: 'round-button'
				});
				this.joined = true
			} else {
				this.joinCheck()
			}

		},
		methods: {
			joinCheck() {
				this.$http.post("/api/ivst_teacher_check", {
					pmid: this.pmid,
					openid: this.openid,
					id: this.ivst_id
				}).then(res => {
					if (res.data.id) {
						this.class_id = res.data.id
						this.teacher_id = res.data.teacher_id
						this.showSearch = false
						this.getList()
					}
				})

			},
			onSearch() {
				if (this.stuForm.username.trim()) {


					this.$http.post("/api/tch_uname_h5login", {
						pmid: this.pmid,
						username: this.stuForm.username.trim(),
						password: this.stuForm.password,
						openid: this.openid,
					}).then(res => {
						if (res.data.classinfo && res.data.classinfo.id) {
							this.class_id = res.data.classinfo.id
							this.teacher_id = res.data.classinfo.teacher_id
							this.showSearch = false
							this.getList()

						}else{
							if(res.data.id){
								Dialog.alert({
									title: '提示',
									message: '您不是班主任，无法查看',
									theme: 'round-button'
								});
							}else{
								Toast("账号或密码错误！");
							}
						}
						
						
					})
				} else {
					Toast("请输入学号！");
				}

			},

			getList() {
				this.$http.post("/api/get_bzr_class_h5", {
					class_id: this.class_id,
					pmid: this.pmid,
					teacher_id:this.teacher_id
				}).then(res => {
					if (res.data.length > 0) {
						for (let stu of res.data[0].students) {
							stu.wanshan = false
							stu.sms = 0

						}

						if (res.data[0].title) {
							this.class_name = res.data[0].title
						}
						console.log(this.class_name)


						this.getIvstJoins(res.data[0].students)
					}
				})
			},
			getIvstJoins(tableData) {

				this.$http.post("/api/get_ivst_joins", {
					ivstid: 45,
					stuids: tableData.map(e => {
						return e.id
					}).join(",")
				}).then(res => {

					for (let stu of tableData) {
						stu.wenjuan = 0
						for (let s of res.data) {
							if (stu.id == s.uid) {
								stu.wenjuan = 1
								break
							}
						}
					}

					this.DataList = tableData
				})

			},
		}
	}
</script>

<style scoped>
	.flexcenter {
		display: -webkit-box;
		display: -webkit-flex;
		display: -moz-box;
		display: -moz-flex;
		display: -ms-flexbox;
		display: flex;
		/* 水平居中*/
		-webkit-box-align: center;
		-moz-box-align: center;
		-ms-flex-pack: center;
		/* IE 10 */
		-webkit-justify-content: center;
		-moz-justify-content: center;
		justify-content: center;
		/* IE 11+,Firefox 22+,Chrome 29+,Opera 12.1*/
		/* 垂直居中 */
		-webkit-box-pack: center;
		-moz-box-pack: center;
		-ms-flex-align: center;
		/* IE 10 */
		-webkit-align-items: center;
		-moz-align-items: center;
		align-items: center;
	}

	.wj {
		padding: 0 15px;
		word-break: break-all;
		overflow: auto;
		background-size: cover;
		height: 100%;
	}

	.required {
		color: orangered;
	}

	.notrequired {
		color: #FFFFFF;
	}

	.xxitem {
		margin-left: 25px;
		padding: 10px;
		border: 1px solid #ccc;
		margin-bottom: 5px;
		border-radius: 4px;
	}

	.choosed {
		color: #007AFF;
		border: 1px solid #007AFF;

	}

	.iconfont {
		display: inline-block;
		transform: translateY(2px);
		vertical-align: top;
	}

	.btntj {
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #00cfdc;
		color: #FFFFFF;
		border-radius: 4px;
	}

	.toast {
		position: fixed;
		width: 70%;
		left: 15%;
		text-align: center;
		padding: 5px 0;
		border-radius: 4px;
		bottom: 50%;
		background: orangered;
		color: #FFFFFF;
		font-size: 14px;
		opacity: 0;
		display: none;
	}

	.alert {
		position: fixed;
		display: none;
		width: 100%;
		height: 100%;
		top: 0;
		z-index: 99;
		background: rgba(0, 0, 0, 0.6);
		opacity: 0;
	}

	.alertbox {
		width: 80%;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 10px;
		margin: 0 auto;
		height: 200px;
	}

	.alerttitle {
		font-size: 16px;
		text-align: center;
		border-bottom: 1px solid #f6f6f6;
		padding-bottom: 10px;
	}

	.alertcontent {
		padding: 20px 0;
		word-break: break-all;
		text-align: center;
	}

	.alertbutton {
		border-top: 1px solid #f6f6f6;
		padding: 10px;
		text-align: center;
		background-color: #007AFF;
		color: #fff;
		border-radius: 6px;

		margin-top: 40px;

	}

	.tiankong {
		display: inline-block;
	}

	.tiankong>input[type='text'] {
		border: 0;
		outline: none;
		width: 100px;
		border-bottom: 1px solid #888;
		text-align: center;
	}

	.submitBtn {
		margin-top: 2vh;
		margin-bottom: 50px;

		.btn {
			display: inline-block;
			padding: 1.4vh 8%;
			background-color: #00CFDC;
			color: #fff;
			font-size: 15px;
			border-radius: 5vw;
			width: 50%;
			text-align: center;
		}

		.btn:active {
			background-color: #007AFF;
		}
	}

	table.gridtable {
		font-family: verdana, arial, sans-serif;
		font-size: 11px;
		color: #333333;
		border-width: 1px;
		border-color: #ccc;
		border-collapse: collapse;
		width: 100%;
	}

	table.gridtable th {
		border-width: 1px;
		padding: 8px;
		border-style: solid;
		border-color: #ccc;
		background-color: #eee;
	}

	table.gridtable td {
		border-width: 1px;
		padding: 8px;
		border-style: solid;
		border-color: #ccc;
		background-color: #ffffff;
	}
</style>
